import { useShortCodeDataCemeteries } from '@/hooks/use-short-code-data/use-short-code-data'
import { FC, useMemo } from 'react'
import { router } from '@lifedot/router'
import Link from 'next/link'
import { css } from '@emotion/react'
import { palette } from '@lifedot/styles/palette'
import { typography } from '@lifedot/styles/typography'
import ChevronRightIcon from '@material-ui/icons/ChevronRight'
import { EventTracker } from '@lifedot/tracking'
import { elementCategories } from '@lifedot/constants/elementCategories'
import { PriceDataRow } from './PriceDataRow'
import { getSortedTop3Prices } from './dependencies'
import { SubHeading } from '@/components/ShortCode/CemeteryIntroduction/SubHeading'

const styles = {
  wrap: css({
    overflowX: 'scroll',
    whiteSpace: 'nowrap',
    table: {
      marginBottom: 0
    }
  }),
  table: css({
    td: {
      textAlign: 'center'
    }
  }),
  linkWrap: css({
    textAlign: 'right',
    marginTop: 8
  }),
  link: css({
    display: 'inline-flex',
    alignItems: 'center',
    color: palette.main03
  })
}

interface PricesProps {
  cemeteryId: number
  choiceCode: string
}

export const Prices: FC<PricesProps> = ({ cemeteryId, choiceCode }) => {
  const [cemetery] = useShortCodeDataCemeteries([cemeteryId])
  const { price_and_specs: priceAndSpecs, name } = cemetery || {}

  const sortedPriceAndSpecs = useMemo(() => {
    if (!priceAndSpecs) return null
    return getSortedTop3Prices(priceAndSpecs, choiceCode)
  }, [priceAndSpecs, choiceCode])

  if (!sortedPriceAndSpecs || sortedPriceAndSpecs.length < 1) return null

  return (
    <section>
      <SubHeading text={`${name}の費用`} />
      <div css={styles.wrap}>
        <table css={[typography.textM, styles.table]}>
          <thead>
            <tr css={typography.textS}>
              <th>区画名</th>
              <th>参考価格</th>
              <th>年間管理費</th>
            </tr>
          </thead>
          <tbody>
            {sortedPriceAndSpecs.map((data) => (
              <PriceDataRow
                name={data.name}
                purchasePrice={data.purchasePrice}
                key={data.priceId}
              />
            ))}
          </tbody>
        </table>
      </div>
      <div css={styles.linkWrap}>
        <EventTracker
          action="click"
          label={`cemeteryIntroduction_price_${cemeteryId}`}
          elementCategory={elementCategories.cemeteryIntroduction}
          elementLabel={`price_${cemeteryId}`}
        >
          <Link
            href={router.price(cemeteryId) + `#${choiceCode}-detail`}
            passHref
            prefetch={false}
          >
            <a css={[typography.textM, styles.link]}>
              費用をすべて見る（{priceAndSpecs?.length}件）
              <ChevronRightIcon fontSize="small" />
            </a>
          </Link>
        </EventTracker>
      </div>
    </section>
  )
}
